import {Menu, Divider, MenuCaption} from '@genestack/ui';
import React from 'react';

import {DocumentTypeLabel} from '../../../../../../components/document-type-label';
import {CommitDto} from '../../../../../../providers/version';

import {EditViewMenuCaption} from './edit-view-menu-caption';
import {EditViewMenuItems} from './edit-view-menu-items';

interface Props {
    document: EditModeDoc;
    lastAction?: CommitDto;
    onClickPublish: () => void;
    onClickRename: () => void;
}

/**
 * Menu which shows some basic info about a BioKB document
 * and provides controls to do some actions over it
 */
export const EditViewEditorMenu = ({
    lastAction,
    document,
    onClickPublish,
    onClickRename,
    ...restProps
}: Props) => {
    return (
        <Menu {...restProps}>
            <MenuCaption>
                <DocumentTypeLabel
                    variant="full"
                    type={document.type}
                    readOnly={document.readOnly}
                />
                <Divider variant="transparent" />
                <EditViewMenuCaption docInfo={document} lastAction={lastAction} />
            </MenuCaption>

            <EditViewMenuItems
                docInfo={document}
                onClickPublish={onClickPublish}
                onClickRename={onClickRename}
            />
        </Menu>
    );
};
